import { motion } from "motion/react";
import { MessageCircle } from "lucide-react";
import { SectionLabel } from "@/components/common/SectionLabel";
import { CATALOG_ITEMS } from "@/constants/catalog";
import { CONTACT_INFO } from "@/constants/company";
import { ANIMATION_VARIANTS } from "@/constants/animations";

export function CatalogSection() {
  return (
    <section id="catálogo" className="py-[120px] bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          variants={ANIMATION_VARIANTS.fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="text-center mb-16"
        >
          <SectionLabel text="Catálogo de Equipamiento" />
          <h2 className="text-4xl font-bold text-[#0A2540] max-w-2xl mx-auto leading-snug mt-2">
            Distribución de productos técnicos de primer nivel
          </h2>
          <p className="mt-6 text-[16px] md:text-[18px] text-[#0A2540]/75 max-w-2xl mx-auto font-normal leading-[1.7]">
            Suministramos equipamiento homologado y certificado
            internacionalmente, garantizando la calidad y durabilidad que sus
            operaciones exigen.
          </p>
        </motion.div>

        <motion.div
          variants={ANIMATION_VARIANTS.staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {CATALOG_ITEMS.map((product, i) => (
            <motion.div
              key={i}
              variants={ANIMATION_VARIANTS.cardVariant}
              whileHover={{
                y: -6,
                boxShadow: "0 20px 48px rgba(10,37,64,0.13)",
              }}
              className="bg-white rounded-lg border border-[#A5E0DF]/40 p-8 flex flex-col items-center hover:border-[#39B5BF]/50 transition-all h-full shadow-sm group"
            >
              <div className="w-full aspect-square relative mb-8 rounded-lg overflow-hidden bg-[#f8fafa] border border-gray-100 flex items-center justify-center p-4">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-contain mix-blend-multiply group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-[#0A2540]/[0.02] mix-blend-overlay z-10" />
              </div>
              <h3 className="text-xl font-bold text-[#0A2540] text-center mb-4">
                {product.title}
              </h3>
              <p className="text-[16px] text-[#0A2540]/75 font-normal leading-[1.7] text-center mb-8 flex-grow">
                {product.description}
              </p>
              <a
                href={`https://wa.me/${CONTACT_INFO.whatsapp.number}?text=${encodeURIComponent(product.whatsappMessage)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-4 rounded-lg font-bold text-[15px] hover:bg-[#20B45B] transition-all shadow-md hover:shadow-lg"
              >
                <MessageCircle className="w-5 h-5" />
                Cotizar por WhatsApp
              </a>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}